{
  "nl": {
    "button": {
      "actions": {
        "add": "Voeg toe",
        "cancel": "Annuleren",
        "close": "Sluit",
        "copyEmail": "Kopieer e-mail",
        "create": "Maak aan",
        "delete": "Verwijderen",
        "display": "Weergave",
        "edit": "Bewerken",
        "hide": "Verberg",
        "loading": "Laden",
        "move": "Verplaats",
        "move_down": "Omlaag verplaatsen",
        "move_up": "Omhoog verplaatsen",
        "no": "Nee",
        "reset": "Reset",
        "save": "Opslaan",
        "save_changes": "Wijzigingen opslaan",
        "save_message": "Bericht opslaan",
        "saving": "Opslaan",
        "share": "Deel",
        "startTour": "Start rondleiding",
        "uploadingDocuments": "Opladen documenten",
        "yes": "Ja"
      }
    }
  }
}
